import ColFive from "../components/FlexView/FlexViewFive/ColFive"
import FlexViewFive from "../components/FlexView/FlexViewFive/FlexViewFive"
import FlexViewFour from "../components/FlexView/FlexViewFour/FlexViewFour"
import DownloadList from "../components/Lists/DownloadList"
import LinksCard from "../components/cards/LinksCard"
import statementsPageData from "../data/english/statments-page-data"
import Footer from "../layouts/Footer"
import MainHeader from "../layouts/MainHeader"

const StatementsPage = () => {
  return (
      <main id="main" className="page">
        <div className="sticky-view">
          <div className="sticky-container">
            <MainHeader 
              title={"Statements and Policies"}
              image={{
                src : require("../assets/images/wallpaper/statements-2.jpg"),
                alt : "Statements and pocilies background"
              }}
            />
          </div>
          <div className="sticky-container-two">
            <div className="space-50"></div>
            <div className="space-50"></div>
            <div className="wrapper-small">
              <p className="text-paragraph">{statementsPageData.paragraphOne}</p>
              <div className="space-50"></div>
              <div className="space-50"></div>
              {/* <FlexViewFive>
                {statementsPageData.cards.map((item, index) => (
                  <ColFive key={index}>
                  <LinksCard 
                    key={index}
                    title={item.title}
                    image={{
                      src : require(`../assets/images/cards/${item.image.name}`),
                      alt : item.image.alt,
                    }}
                    links={[item.linkOne]}
                  />
                  </ColFive>
                ))}
              </FlexViewFive> */}
              <DownloadList data={[
                // {
                //   name : "Compliance with Regulations (PDF )",
                //   path : './'
                // },
                {
                  name : "Governance at SAB Principles and Practices (PDF)",
                  path : "./Governance at SAB Principles and Practices.pdf"
                },
                {
                  name : "Analysis of SAB’s Sector Exposure (PDF)",
                  path : "./Analysis_SAB_Exposure.pdf"
                },
                {
                  name : "SAB Health and Safety Statement (PDF)",
                  path : "./SAB_Health_and_Safety_Statement.pdf"
                },
                {
                  name : "Risk Management Policy Statement (PDF)",
                  path : "./Risk_Management_Update_Disclosure.pdf"
                },
                {
                  name : "SAB Human Rights Statement (PDF)",
                  path : "./SAB_Human_Rights_Statement.pdf"
                },
                {
                  name : "Personal Data Protection – Privacy Notice (PDF)",
                  path : "./Personnal_Data_Protection_(PDP)_Privacy_Notice_(Final)A.pdf"
                },
                {
                  name : "Anti-Bribery & Corruption Policy (PDF)",
                  path : "./Anti-Bribery_and_Corruption_Policy.pdf"
                },
                {
                  name: "Anti-Money Laundering Policy (PDF)",
                  path: "./Anti-Money_Laundering_Policy.pdf"
                },
                {
                  name: "Bylaws of Saudi Awwal Bank (PDF)",
                  path: "./Bylaws_of_Saudi_Awwal_Bank.pdf"
                },
                {
                  name: "Code of Conduct For Board & Board Committee Members (PDF)",
                  path: "./Code_of_Conduct_For_Board_&_Board_Committee_Members.pdf"
                },
                {
                  name: "Consumer Protection Policy (PDF)",
                  path: "./Consumer_Protection_Policy.pdf"
                },
                {
                  name : "Corporate Social Responsibility Policy (PDF)",
                  path : "./Corporate_Social_Responsibility_Policy.pdf"
                },
                {
                  name : "Ethical and Environmental Code of Conduct for Suppliers of Goods and Services (PDF) ",
                  path : "./Ethical_and_Environmental_Code_of_Conduct_for_Suppliers_of_Goods_and_Services.pdf",
                },
                {
                  name : "Professional Code of Conduct for Employees (PDF ) ",
                  path : "./Professional_Code_of_Conduct_for_Employees.pdf",
                },
                {
                  name : "Related-Party Transaction Policy (PDF) ",
                  path : "./Related-Party_Transaction_Policy.pdf",
                },
                {
                  name : "Remuneration_Policy for Board Directors, Committee Members & Executive Management (PDF) ",
                  path : "./Remuneration_Policy_for_Board_Directors_Committee_Members_&_Executive_Management.pdf",
                },
                {
                  name : "Selection Policy for Board and Board Committee Members (PDF)",
                  path : "./Selection_Policy_for_Board_and_Board_Committee_Members.pdf",
                },
                {
                  name : "Whistleblowing_Policy.pdf (PDF) ",
                  path : "./Whistleblowing_Policy.pdf",
                },
              ]} />
            </div>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <Footer withBlogs={false} />
          </div>
        </div>
      </main>
  )
}

export default StatementsPage